import { useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "Asia/Ho_Chi_Minh";
const WEEKDAYS = ["Chủ nhật", "Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7"];
const WEEKDAYS_SHORT = ["CN", "T2", "T3", "T4", "T5", "T6", "T7"];

export default function DatePicker({
  labelToday = "Hôm nay",
  initDate,
  direction = "forward",
  days = 7,
  onDateSelect,
  compact = false,
}) {
  const toKey = (value) => dayjs(value).tz(TZ).format("YYYY-MM-DD");
  const [selectedDate, setSelectedDate] = useState(() => toKey(initDate || new Date()));

  useEffect(() => {
    if (initDate) setSelectedDate(toKey(initDate));
  }, [initDate]);

  const chips = useMemo(() => {
    const today = dayjs().tz(TZ).startOf("day");
    const sign = direction === "backward" ? -1 : 1;
    const items = [];
    for (let i = 0; i <= days; i++) {
      const d = today.add(i * sign, "day");
      items.push({
        key: d.format("YYYY-MM-DD"),
        date: d,
        isToday: i === 0,
        weekday: compact ? WEEKDAYS_SHORT[d.day()] : WEEKDAYS[d.day()],
        ddmm: d.format("DD/MM"),
      });
    }
    return items;
  }, [compact, direction, days]);

  const handleSelect = (chip) => {
    setSelectedDate(chip.key);
    onDateSelect?.(chip.date.toDate());
  };

  return (
    <div className="w-full">
      <div
        className={`date-picker-scroll kbv-ltd-date-row flex flex-nowrap items-center gap-1.5 overflow-x-auto overflow-y-hidden${
          compact ? " is-compact" : ""
        }`}
      >
        <span className="kbv-ltd-filter-spacer" aria-hidden="true" />
        {chips.map((chip) => {
          const isActive = selectedDate === chip.key;
          return (
            <button
              key={chip.key}
              type="button"
              onClick={() => handleSelect(chip)}
              className={`kbv-ltd-chip ${isActive ? "is-active" : ""}`}
            >
              <span className="kbv-ltd-chip-label flex items-center gap-1 whitespace-nowrap">
                {chip.isToday ? (
                  <span>{labelToday}</span>
                ) : compact ? (
                  <>
                    <span>{chip.weekday}</span>
                    <span>{chip.ddmm}</span>
                  </>
                ) : (
                  <>
                    <span>{chip.weekday}</span>
                    <span>({chip.ddmm})</span>
                  </>
                )}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
